import { showTabPanel } from "../../../Store/slices/ui-slice";
import { store } from "../../../Store/store/store";

const { dispatch } = store;

export function handleExpand() {
  dispatch(showTabPanel(true));
}
